import { useState, useEffect } from 'react';
import useMediaQuery from './useMediaQuery';
import { getIsStandalone, getIsNative } from '../shared/utils/general.util';

export type MobilePlatform = 'android' | 'ios' | null;

const detectMobilePlatform = (): MobilePlatform => {
	const userAgent = navigator.userAgent || navigator.vendor;
	const isAndroid = /android/i.test(userAgent);
	const isIOS = /iPad|iPhone|iPod/.test(userAgent);

	if (!isAndroid && !isIOS) return null;

	const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
	if (!isTouchDevice) return null;

	if (window.screen.width > 1024) return null;

	if (isAndroid) return 'android';
	if (isIOS) return 'ios';
	return null;
};

const usePlatform = () => {
	const isMobile = useMediaQuery('(max-width: 768px)');
	const [mobilePlatform, setMobilePlatform] = useState<MobilePlatform>(null);
	const [isPWA, setIsPWA] = useState(false);

	useEffect(() => {
		setMobilePlatform(detectMobilePlatform());
		setIsPWA(getIsStandalone() || getIsNative());
	}, []);

	return { isMobile, mobilePlatform, isPWA };
};

export default usePlatform;
